import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.25 6.25h-2.5V4.375a3.75 3.75 0 0 0-7.5 0V6.25h-2.5A1.25 1.25 0 0 0 2.5 7.5v8.75a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V7.5a1.25 1.25 0 0 0-1.25-1.25M7.5 4.375a2.5 2.5 0 1 1 5 0V6.25h-5zm8.75 11.875H3.75V7.5h12.5zm-5.312-4.375a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.874 0"
    }, null, -1)
  ])))
}
export default { render: render }